var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.36 4H4.64003C4.28603 4 4.00003 4.286 4.00003 4.64V19.36C4.00003 19.714 4.28603 20 4.64003 20H19.36C19.714 20 20 19.714 20 19.36V4.64C20 4.286 19.714 4 19.36 4ZM18.72 18.72H15.038V13.804H17.118L17.43 11.39H15.038V9.848C15.038 9.148 15.232 8.672 16.234 8.672H17.512V6.512C17.29 6.482 16.532 6.416 15.648 6.416C13.804 6.416 12.542 7.542 12.542 9.608V11.388H10.458V13.802H12.544V18.72H5.28003V5.28H18.72V18.72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOutlined);
export default __webpack_public_path__ + "static/media/facebook_outlined.c0671a57c062f98681ad11a157ede7f0.svg";
export { ForwardRef as ReactComponent };